import FilterDateLast12Months from "./FilterDateLast12Months";
const FilterChargedOffDate = (props: any) => {
  const before = props?.before;

  return (
    <FilterDateLast12Months
      source="limitChargedOffDate"
      label="Charged-Off Date"
      variant="outlined"
      {...props}
    />
  );
};

export default FilterChargedOffDate;
